import React, { useEffect, useRef, useState } from 'react'
import { clickOutside } from '../../utils';

export const OrderCell = ({value, expanding = false, maxWidth = '300%', c = {}}) => {

    const [isOpened, setOpen] = useState(false);
    const cellRef = useRef(null);
    useEffect(() => {
        if (!isOpened) return;
        const clickOutsideHandler = (evt) => clickOutside(evt, cellRef, setOpen);
        document.addEventListener('mousedown', clickOutsideHandler);
        document.addEventListener('contextmenu', clickOutsideHandler);
        return () => {
            document.removeEventListener('mousedown', clickOutsideHandler);
            document.removeEventListener('contextmenu', clickOutsideHandler);
        }
    }, [isOpened]);
    
    return expanding && isOpened  && value !== '' && value !== null ? (
        <div className='cell expanded' ref={cellRef} style={{maxWidth}}>
            <div style={{maxWidth}}>{value}</div>
        </div>
    ) : <div className='cell' style={c} onClick={() => setOpen(true)}>{value}</div>
}
